"use strict";
// import { cookies } from 'next/headers';
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const growthbook_1 = require("@growthbook/growthbook");
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const initGrowthBookServerComponent = (growthBookOptions) => __awaiter(void 0, void 0, void 0, function* () {
    const gb = new growthbook_1.GrowthBook(growthBookOptions);
    // const clientID = cookies()?.get('_ga')?.value;
    // await gb.setAttributes({
    //   id: clientID,
    //   clientId: clientID,
    // });
    yield gb.init({ timeout: 1000 });
    return gb;
});
exports.default = initGrowthBookServerComponent;
